import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import InterviewerFeedbackWizard from '../components/InterviewerFeedbackWizard';
import '../LiveInterview.css';

/**
 * Standalone route for email feedback links: /interview-feedback?token=...
 */
export default function InterviewerFeedbackPage() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => {
    const fromQuery = (searchParams.get('token') || '').trim();
    if (fromQuery) return fromQuery;
    if (typeof window !== 'undefined') {
      return String(window.__INTERVIEWER_FEEDBACK_TOKEN__ || '').trim();
    }
    return '';
  }, [searchParams]);

  const [submitted, setSubmitted] = React.useState(false);

  return (
    <div className="live-interview-page">
      <div
        className={`live-interview-shell${
          submitted ? ' live-interview-shell--feedback-success' : ''
        }`}
        style={{ maxWidth: 720, margin: '0 auto' }}
      >
        {submitted ? (
          <div
            className="li-feedback-choice-card li-feedback-page-success-card"
            role="status"
            aria-live="polite"
          >
            <p className="li-feedback-eyebrow">Thank you</p>
            <h1 className="li-feedback-title">Feedback submitted</h1>
            <p className="li-feedback-sub">
              Your responses were saved. You can close this window.
            </p>
          </div>
        ) : (
          <>
            <header className="live-interview-header">
              <p className="live-interview-kicker">Post-interview</p>
              <h1 className="live-interview-title">Interviewer feedback</h1>
              <p className="live-interview-subtitle">
                Voice-guided session (~5 minutes). Review and edit answers before submitting.
              </p>
            </header>

            {token ? (
              <InterviewerFeedbackWizard
                open
                variant="standalone"
                token={token}
                onSubmitted={() => setSubmitted(true)}
              />
            ) : (
              <div className="li-modal-error" role="alert">
                This feedback link is missing or invalid. Open the link from your email again.
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
